import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=43c00afa&scoped=true"
import script from "./ProductSearch.vue?vue&type=script&lang=js"
export * from "./ProductSearch.vue?vue&type=script&lang=js"
import style0 from "./ProductSearch.vue?vue&type=style&index=0&id=43c00afa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c00afa",
  null
  
)

export default component.exports